import styled from "styled-components";
import { Modal } from "waapi/waap-ui/components/Modal/Modal.js";

export const StyledModal = styled(Modal)`
    background-color: ${({ theme }) => theme.grayscale.white};
`;
